module.exports = __webpack_public_path__ + "static/img/bg.52e651b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/bg.png
// module id = fj4l
// module chunks = 1